import { useContext } from 'react';

import type { AvailablePaymentMethodsState } from './context';
import { AvailablePaymentMethodsContext } from './context';

export function useAvailablePaymentMethods(): AvailablePaymentMethodsState {
	return useContext(AvailablePaymentMethodsContext);
}
